import { makeStyles } from '@material-ui/styles';
import { ITheme } from '../../typings/theme';

export default makeStyles((theme: ITheme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
